import React from 'react'
import './Performancecard.css'

const Permormance = ({teamname, bcolor, bwidth}) => {
    // console.log(bwidth)
  return (
    <div className='performance-container'>
        <div className='performance-container-top'>
            <span>{teamname}</span>
            <span>{bwidth}</span>
        </div>

        <div className='performance-container-bottom'>
            <div className='performance-loader' style={{ backgroundColor: `${bcolor}`, width: `${bwidth}`}} />
        </div>
    </div>
  )
}

export default Permormance